import {
  IIncidentNotificationWsMessage,
  INotification,
  INotificationWsMessage,
} from '@/services/Notification/notifications.types.ts'
import { useRecoilValue } from 'recoil'
import equipmentSelectors from '@/pages/Equipment/equipment.selectors.ts'
import {
  ILPErrorSystemEvent,
  IMovedToMaintenanceSystemEvent,
  ISystemEvent,
} from '@/pages/SystemEvents/systemEvents.types'
import { IEquipment } from '@/pages/Equipment/equipment.types'
import equipmentUtils from '@/pages/Equipment/equipment.utils'

interface IProps {
  notification: INotificationWsMessage | INotification | ISystemEvent
}

const NotificationDescription = (props: IProps) => {
  const equipmentMap = useRecoilValue(equipmentSelectors.getEquipmentMap)
  if ('id' in props.notification) {
    switch (props.notification.type) {
      case 'LIFT_ERROR':
      case 'MAINTENANCE_OVERDUE_WARNING':
      case 'MAINTENANCE_OVERDUE_FACT':
      case 'TEXT':
        return props.notification.text
    }
  }

  const getLpErrorDescription = (event: ILPErrorSystemEvent, equipment: IEquipment) => {
    if (!equipment) {
      return 'Оборудование не найдено. Обратитесь к администратору.'
    }

    return event.payload.errorDescription
  }

  switch (props.notification.type) {
    case 'ALARM_SITUATION_INCIDENT':
      const relatedEquipment = equipmentMap[(props.notification as IIncidentNotificationWsMessage).payload.equipmentId]
      return `Сработка сигнальной ситуации у лифта по адресу ${equipmentUtils.getEquipmentAddress(relatedEquipment?.location) || 'Неизвестно'}`
    case 'SYSTEM_LOG':
    case 'CONNECTION_REQUEST':
      return props.notification.description
    case 'LP_ERROR':
      return 'description' in props.notification
        ? props.notification.description
        : getLpErrorDescription(
            props.notification,
            equipmentMap[(props.notification as ILPErrorSystemEvent).payload.equipmentId]
          )
    case 'MOVED_TO_MAINTENANCE':
    case 'MOVED_FROM_MAINTENANCE_TO_NORMAL':
      const equipment = equipmentMap[(props.notification as IMovedToMaintenanceSystemEvent).payload.equipmentId]
      return `Лифт по адресу ${equipmentUtils.getEquipmentAddress(equipment?.location) || 'Неизвестно'}`
    case 'MAINTENANCE_OVERDUE_WARNING':
    case 'MAINTENANCE_OVERDUE_FACT':
    case 'LIFT_ERROR':
    case 'TEXT':
      return props.notification.payload.text
    default:
      return 'Системное уведомление'
  }
}

export default NotificationDescription
